import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { appRoute } from "./route";
import { InvitationList } from "@/features/organizations/components/invitation-list";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@fleet/ui";

function InvitationsPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Invitations`)}
      description={t(msg`Manage your pending invitations and join new organizations.`)}
    >
      <PageContainer maxWidth="3xl">
        <InvitationList />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const invitationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/invitations",
  component: InvitationsPage,
});
